import { useTranslation } from "../i18n/useTranslation";

interface FeedbackOverlayProps {
  correct: boolean;
  /** Optional detail line (e.g. "Answer: 4 7 2 9"). Already localized. */
  detail?: string;
}

export function FeedbackOverlay({ correct, detail }: FeedbackOverlayProps) {
  const { t } = useTranslation();
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center bg-bg-1/95 z-30 pointer-events-none">
      <span
        className={[
          "text-5xl md:text-7xl font-medium tracking-[-0.02em]",
          correct ? "text-green" : "text-red",
        ].join(" ")}
      >
        {correct ? t("common.correct") : t("common.wrong")}
      </span>
      {detail && (
        <span className="mt-4 text-fg-2 font-mono text-sm tracking-[0.04em]">
          {detail}
        </span>
      )}
    </div>
  );
}
